// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2eyRM","messages":"Chat_messages__tLavg","dateDivider":"Chat_dateDivider__WzRTW"};